import React, { useEffect, useState } from "react"
import Select from "react-select"
import { Controller } from "react-hook-form"
import { materiarRequestProductlist } from "../../../services/procurement/materialrequest"
import { getProductCodeProjectNum } from "../../../services/Settings/dropdown"

function ucfirst(str) {
  var firstLetter = str.substr(0, 1)
  return firstLetter.toUpperCase() + str.substr(1)
}

const ProductNum = ({
  control,
  name,
  onSelectChange,
  target,
  placeholder,
  projectNo,
}) => {
  console.log(`projectNo`, projectNo)
  const [isLoading, setIsLoading] = useState(false)
  const [fetchResponse, setFetchResponse] = useState([])
  const loadOptions = async () => {
    const data = await getProductCodeProjectNum(projectNo?.id)
    setIsLoading(true)
    const response = data?.data?.map(dta => {
      return {
        label:
          dta?.product_id?.product_code && ucfirst(dta?.product_id?.product_code),
        value: dta.product_id?.id,
        ...dta,
      }
    })

    setFetchResponse(response)

    setIsLoading(false)
  }
  useEffect(() => {
    if (projectNo != undefined) {
      loadOptions()
    }
  }, [projectNo])

  return (
    <div>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, ref, value } }) => {
          return (
            <Select
              options={fetchResponse}
              // placeholder={placeholder ? placeholder : "Select"}
              placeholder={
              <div className="css-placeholder">
                {placeholder || "Select"} 
              </div>
            }
              isLoading={isLoading}
              inputRef={ref}
              onChange={e => {
                onChange(e)
                if (onSelectChange) onSelectChange(e)
              }}
              value={value}
              classNamePrefix="react-select"
              className="elevate-dropdown"
              menuPortalTarget={document.querySelector(
                target ? target : ".modal"
              )}
            />
          )
        }}
      />
    </div>
  )
}

export default ProductNum
